import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { register as registerSW, activateUpdate } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registrer service worker og send oppdateringer videre til appen via event.
// App lytter på 'fiskda:sw-update' og viser en toast der brukeren kan oppdatere.
registerSW({
  onUpdate: (registration) => {
    window.dispatchEvent(
      new CustomEvent('fiskda:sw-update', {
        detail: { activate: () => activateUpdate(registration) },
      })
    );
  },
});
